import type { EnumConfigOption } from './GlobalType';

export function enumListToRecord(
  options: EnumConfigOption[],
): Record<string, EnumConfigOption> {
  if (!Array.isArray(options)) {
    return {};
  }
  return options.reduce<Record<string, EnumConfigOption>>((acc, item) => {
    acc[String(item.id)] = item;
    return acc;
  }, {});
}
